import { render, staticRenderFns } from "./NotInTariffTooltip.vue?vue&type=template&id=af8d7b84&scoped=true"
import script from "./NotInTariffTooltip.vue?vue&type=script&lang=ts"
export * from "./NotInTariffTooltip.vue?vue&type=script&lang=ts"
import style0 from "./NotInTariffTooltip.vue?vue&type=style&index=0&id=af8d7b84&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af8d7b84",
  null
  
)

export default component.exports